import { Button } from 'antd'
import styled, { css } from 'styled-components'

export const ButtonCustom = styled(Button)`
  width: 200px;
`

export const ButtonWrapper = styled.div`
  display: flex;
`

export const ButtonActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 30px;
  margin-left: 455px;
`
export const CustomRowTable = styled.div<{ type?: string; isWarning?: boolean }>`
  text-align: ${({ type }) => type};

  ${({ isWarning }) =>
    isWarning &&
    css`
      background-color: #ec221f;
      color: #fff;
      padding-right: 3px;
    `}
`
